import {BffCompany} from '../../../types/bffTypes';
import {formatRange} from '../../../utils';

export const displaySize = (size: NonNullable<BffCompany['size']>) => `${formatRange(size)} employees`;
